// Schema data
export const FETCH_SCHEMA_DATA_SUCCESS = "FETCH_SCHEMA_DATA_SUCCESS";

// Current user
export const FETCH_CURRENT_USER = "FETCH_CURRENT_USER";
export const EDIT_USER_SETTINGS = "EDIT_TIME_ZONE";

// Announcements
export const SET_ACTIVE_ANNOUNCEMENT = "SET_ACTIVE_ANNOUNCEMENT";
